import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f6ae522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-group" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-between pt-2 pb-1" }
const _hoisted_3 = { class: "form-check form-switch mb-0" }
const _hoisted_4 = ["id", "value", "aria-describedby", "onChange"]
const _hoisted_5 = ["for", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recursive_taxonomy_group = _resolveComponent("recursive-taxonomy-group", true)!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tax.items, (item, termId) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass('list-group-item' + (_ctx.groupClass ? ' ' + _ctx.groupClass : '')),
        key: termId
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: _ctx.switchId(termId),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkboxes) = $event)),
              value: termId,
              "aria-describedby": _ctx.switchId(termId),
              onChange: ($event: any) => (_ctx.updateTaxonomy(_ctx.slug, termId))
            }, null, 40, _hoisted_4), [
              [_vModelCheckbox, _ctx.checkboxes]
            ]),
            _createElementVNode("label", {
              class: "form-check-label",
              for: _ctx.switchId(termId),
              innerHTML: item.name
            }, null, 8, _hoisted_5)
          ])
        ]),
        (item.items)
          ? (_openBlock(), _createBlock(_component_recursive_taxonomy_group, {
              key: 0,
              ref_for: true,
              ref: "recursiveTaxonomyGroup",
              tax: item,
              slug: _ctx.slug,
              groupClass: "border-0",
              onUpdateTaxonomy: _ctx.updateTaxonomy
            }, null, 8, ["tax", "slug", "onUpdateTaxonomy"]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}